import PropTypes from "prop-types";
import styles from "./calculator.module.scss";

const CalculatorPanel = ({
  header = "Calculator",
  onClear,
  children,
  errors = {},
}) => (
  <div className={styles.panel}>
    <div className={styles.panelHeader}>
      <span></span>
      {onClear && (
        <button type="button" className={styles.clearBtn} onClick={onClear}>
          Clear all
        </button>
      )}
    </div>
    <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
      <div className={styles.fields}>
        {children}
        {Object.keys(errors).map(
          (k) =>
            errors[k] && (
              <div className={styles.error} key={k}>
                {errors[k]}
              </div>
            ),
        )}
      </div>
    </form>
  </div>
);

CalculatorPanel.propTypes = {
  header: PropTypes.node,
  onClear: PropTypes.func,
  children: PropTypes.node.isRequired,
  errors: PropTypes.object,
};

export default CalculatorPanel;
